export default __webpack_public_path__ + "static/LifeStyleChoices-fc733e3b699accd1c492f2a22244dc66.png";